<div class="asin-list-wrapper flex flex-col" *transloco="let t">
  <div class="asin-list-header">
    <div class="flex min-w-0 flex-1 items-center">
      <ISwitchButton
        class="rank-switch mr-2"
        [buttonTexts]="childParentSwitchText"
        [options]="childParentSwitchValues"
        [buttonTooltips]="['', '']"
        [selected]="childParentSwitchValues[0]"
        (buttonClicked)="switchGroupBy($event)"
      ></ISwitchButton>
      <div iInputGroup>
        <IIcon name="search" iInputGroupPrefix />
        <input
          iInputGroupInput
          [placeholder]="t('tracked-asin-selection.filter_by_asin')"
          size="sm"
          class="flex-2"
          (input)="searchAsin($event.target.value)"
        />
      </div>
      <IMultiSelectMenu [value]="selectedQuickFilters()" (valueChange)="updateQuickFilter($event)" class="ml-2 min-w-0">
        <ISelectTrigger>
          <ISelectValue [placeholder]="t('common.none')">
            <div class="truncate" *iSelectValue="let value">
              {{ t("common.selected", { count: selectedQuickFilters().length }) }}
            </div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          @for (option of quickFilterOptions; track option.value) {
            <ISelectOption [value]="option">
              {{ option.label }}
            </ISelectOption>
          }
        </ISelectContent>
      </IMultiSelectMenu>
    </div>

    <div style="height: 3.8rem"></div>
    @if (selectedRankOption() === RankOption.BOTH) {
      <div style="height: 2rem"></div>
    }
  </div>
  <div class="list-header flex justify-between px-2">
    <div class="inline-flex items-baseline">
      <span>{{ t("common.product") }}</span>
      <button iButton variant="secondary" size="xs" class="ml-2" [disabled]="!!isReadOnly()" (click)="openInputModal()">
        {{ t("tracked-asin-selection.add_new_product") }}
      </button>
    </div>
    <span style="margin-right: 2rem">BSR</span>
  </div>
  <div class="asin-list-content mt-2" #asinListScroll (scroll)="updateScroll('asinListScroll', $event)">
    <div>
      @for (p of asinRanks$ | async; track p; let i = $index) {
        <div>
          @if ((groupByParent$ | async) && !(p.childrenRow?.length === 1 && p.childrenRow![0]!.asin === p.asin)) {
            <ng-container *ngTemplateOutlet="productCard; context: { product: p }"></ng-container>
          }
          @for (a of p.childrenRow; track a; let y = $index) {
            <div
              [ngClass]="{
                'child-asin pl-3':
                  (groupByParent$ | async) && !(p.childrenRow![0] && p.childrenRow![0].asin === p.asin),
              }"
            >
              <ng-container *ngTemplateOutlet="productCard; context: { product: a }"></ng-container>
            </div>
          }
        </div>
      }
    </div>
    @if ((asinRanks$ | async)?.length === 0) {
      <div class="flex h-full items-center justify-center">
        <span>{{ t("tracked-asin-selection.no_result") }}</span>
      </div>
    }
  </div>
</div>

<ng-template #productCard let-product="product">
  <div
    [ngClass]="{ selected: (graphAsin$ | async) === product.asin }"
    (mouseenter)="onHover(product.asin)"
    (mouseleave)="onLeave()"
    (click)="toggleGraphAsin(product.asin)"
    class="product-card relative flex items-center px-2 py-2"
    *transloco="let t"
  >
    <div class="flex w-full items-center">
      <div class="image-wrapper">
        <img class="product-image" [src]="(products().get(product.asin) | async)?.imageUrl" />

        @if (products().get(product.asin) | async; as pr) {
          <a class="link flex items-center justify-center" target="_blank" [href]="getAmazonProductUrl(pr)">
            <IIcon name="link" class="text-white" />
          </a>
        }
      </div>
      <div class="product-detail">
        <div class="truncate">{{ (products().get(product.asin) | async)?.title }}</div>
        <div class="truncate" style="font-size: 0.9rem">
          <span class="color-tag" [style.background-color]="productColor().get(product.asin)"></span> {{ product.asin }}
        </div>
      </div>
      <div class="font-xl ml-3 font-semibold">{{ (products().get(product.asin) | async)?.categoryRank }}</div>
      @if (selectedRankOption() !== RankOption.BOTH || (tableView$ | async) === true) {
        <div
          [iTooltip]="(hiddenAsins$ | async)?.has(product.asin) ? t('common.display_asin') : t('common.hide_asin')"
          (click)="hideAsin($event, product.asin)"
          class="icon-eye ml-3"
        >
          @if ((hiddenAsins$ | async)?.has(product.asin)) {
            <IIcon name="eyeClosed" class="text-lg" />
          } @else {
            <IIcon name="eye" class="text-lg" />
          }
        </div>
      }
    </div>
  </div>
</ng-template>
